import { View } from 'react-native';

import { MIN_PASSWORD_LENGTH } from '@/lib/constants';

import { cn } from './cn';
import { Text } from './Text';

/** 0–4 strength score. */
export function passwordStrength(pw: string): number {
  let s = 0;
  if (pw.length >= MIN_PASSWORD_LENGTH) s++;
  if (/[A-Z]/.test(pw) && /[a-z]/.test(pw)) s++;
  if (/\d/.test(pw)) s++;
  if (/[^A-Za-z0-9]/.test(pw)) s++;
  return s;
}

const SEG_ON = ['bg-alert', 'bg-alert', 'bg-caution', 'bg-positive', 'bg-positive'];
const STRENGTH_LABEL = ['Too short', 'Weak', 'Okay', 'Strong', 'Strong'];

export function PasswordStrengthMeter({ value }: { value: string }) {
  const score = passwordStrength(value);
  const on = SEG_ON[score];
  return (
    <View className="gap-1">
      <View className="flex-row gap-1">
        {[0, 1, 2, 3].map((i) => (
          <View
            key={i}
            className={cn('h-1 flex-1 rounded-full', i < score ? on : 'bg-well')}
          />
        ))}
      </View>
      {value.length > 0 ? (
        <Text variant="caption" className="text-faint">
          {STRENGTH_LABEL[score]}
        </Text>
      ) : null}
    </View>
  );
}
